'use client';

export default function Page() {
  return (
    <>
      <section className="section-md bg-gradient-to-b from-primary/20 to-background/5">
        <div className="container container-max">
          {/* Hero Section */}
          <div className="space-y-4 text-center">
            <h1 className="mb-6 font-extrabold text-transparent hero-title bg-clip-text bg-gradient-to-l from-primary to-secondary ">
              Cookie Policy
            </h1>
            <p className="max-w-3xl mx-auto text-lg text-foreground/70">
              Effective Date: January 2025
            </p>
          </div>
        </div>
      </section>
      <section className="section-md">
        <div className="container space-y-12 container-md">
          <p className="mb-4">
            At <strong>PayStop</strong>, we use cookies to enhance your experience while using our
            platform, which includes our website and mobile applications (collectively referred to
            as the "Platform"). This Cookie Policy explains what cookies are, how we use them, and
            how you can manage them.
          </p>
          <p className="mb-6">
            By using our Platform, you consent to our use of cookies in accordance with this policy.
            If you do not agree with our use of cookies, please disable them by following the
            instructions below or discontinue your use of our Platform.
          </p>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">1. What Are Cookies?</h2>
          <p className="mb-4">
            Cookies are small text files that are placed on your device when you visit a website.
            They help the website remember your actions and preferences over time, so you don’t have
            to re-enter them each visit.
          </p>
          <ul className="pl-6 mb-6 list-disc">
            <li>
              <strong>First-party cookies:</strong> Set by the website you visit.
            </li>
            <li>
              <strong>Third-party cookies:</strong> Set by external services, such as analytics
              providers or advertisers.
            </li>
          </ul>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">2. How We Use Cookies</h2>
          <ul className="pl-6 mb-6 list-disc">
            <li>
              <strong>Improving User Experience:</strong> Remembering your preferences and
              customizing content.
            </li>
            <li>
              <strong>Authentication and Security:</strong> Keeping your account secure and
              preventing unauthorized access.
            </li>
            <li>
              <strong>Analytics and Performance:</strong> Understanding how users interact with our
              Platform.
            </li>
            <li>
              <strong>Marketing:</strong> Tracking browsing habits for personalized advertising.
            </li>
          </ul>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">3. Types of Cookies We Use</h2>
          <ul className="pl-6 mb-6 list-disc">
            <li>
              <strong>Strictly Necessary Cookies:</strong> Essential for core functionality.
            </li>
            <li>
              <strong>Performance and Analytics Cookies:</strong> Help improve platform performance
              (e.g., Google Analytics).
            </li>
            <li>
              <strong>Functionality Cookies:</strong> Remember your settings and preferences.
            </li>
            <li>
              <strong>Targeting and Advertising Cookies:</strong> Deliver personalized
              advertisements.
            </li>
          </ul>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">4. Managing Cookies</h2>
          <p className="mb-4">
            You can manage or disable cookies via your web browser settings. Methods may vary, but
            common options include:
          </p>
          <ul className="pl-6 mb-6 list-disc">
            <li>
              <strong>Browser settings:</strong> Adjust cookie preferences in your browser.
            </li>
            <li>
              <strong>Browser extensions:</strong> Use add-ons for advanced cookie management.
            </li>
          </ul>
          <p className="mb-6">
            Note: Disabling cookies may affect functionality and user experience on our Platform.
          </p>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">5. Third-Party Cookies</h2>
          <p className="mb-4">
            We use third-party service providers for analytics and advertising. These providers may
            set cookies on your device. Examples include:
          </p>
          <ul className="pl-6 mb-6 list-disc">
            <li>
              <strong>Google Analytics:</strong> Tracks user activity to help us improve our
              services.
            </li>
            <li>
              <strong>Advertising Networks:</strong> Provide targeted ads based on browsing
              behavior.
            </li>
          </ul>
          <p className="mb-6">Refer to third-party privacy policies for more information.</p>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">6. Changes to This Cookie Policy</h2>
          <p className="mb-6">
            We may update this Cookie Policy periodically. Changes will be posted here, so please
            review this page regularly.
          </p>

          <h2 className="mt-6 mb-2 text-2xl font-semibold">7. Contact Us</h2>
          <p className="mb-4">For questions regarding this Cookie Policy, contact us:</p>
          <ul className="pl-6 mb-6 list-disc">
            <li>
              <strong>Email:</strong>{' '}
              <a className="text-primary" href="mailto:support@paystop.io">
                support@paystop.io
              </a>
            </li>
            <li>
              <strong>Phone:</strong> +237 676962723
            </li>
            <li>
              <strong>Address:</strong> Crystal Finance Commercial Avenue Bamenda, P.O. Box 168
              Bamenda Cameroon
            </li>
          </ul>

          <p className="mt-6">
            By continuing to use the PayStop Platform, you consent to our use of cookies as
            described in this policy.
          </p>
        </div>
      </section>
    </>
  );
}
